import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState, useMemo} from 'react';
import {connect} from 'react-redux';
import {
  fetchExistingRequests,
  setCurrentStep,
  getWorkOrderData,
  setCurrentPopUp,
  saveToHistory,
  setLoadingMoreRows,
  setSelectedWorkOrderRow,
  resetWorkOrderData,
} from '../BusinessWorkOrderSystemSlice';
import {setSelectedHetPayAllowedToActions, setSelectedHetPay} from 'app/Components/Block/PortalsBlock/portalSlice';
import {BusinessWorkOrderSystemStep, BusinessWorkOrderSystemPopup} from '../Constant/Constant';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {formatDateString14digits} from 'app/utilities/StringHelpers/StringHelpers';
import FlexibleTable from 'app/Components/Shared/FlexibleTable/FlexibleTable';
import BtnWhiteBlackBorder from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import ReactSelect from 'app/Components/Shared/ReactSelect/ReactSelect';
import {getFormatDate} from 'app/utilities/dateUtils';
import {isMobile} from 'react-device-detect';
import BtnNextStep from '../BtnNextStep';

const WorkOrderDashboard = (props) => {
  const [showOpenedBy, setShowOpenedBy] = useState(false);
  const [currentFilterValues, setCurrentFilterValues] = useState(null);

  useEffect(() => {
    let defaultDates = getDefaultDates();

    const req = {
      OrgId: props.portalsBlock.selectedHetPayId,
      FromDate: defaultDates.startDate,
      ToDate: defaultDates.endDate,
    };
    props.fetchExistingRequests(req);
    props.resetWorkOrderData();
  }, []);

  useEffect(() => {
    props.saveToHistory();
  }, [props.businessWorkOrderSystem.dashboardData]);

  function loadMore() {
    const req = {
      OrgId: props.portalsBlock.selectedHetPayId,
      Page: props.businessWorkOrderSystem.dashboardDataCurrentPage + 1,
      // Include current filter values if they exist
      ...(currentFilterValues && {
        FromDate: currentFilterValues.startDate || '',
        ToDate: currentFilterValues.endDate || '',
        FuStatus: currentFilterValues.fuStatusDescription || '',
        AllContactPersons: currentFilterValues.openedBy === 'my' ? 'false' : 'true',
        FuSubscriberOrId: currentFilterValues.fuSubscriberOrFuId || '',
      }),
    };
    props.setLoadingMoreRows();
    props.fetchExistingRequests(req);
  }

  function submitSearching(filterValues) {
    // Save filter values for loadMore
    setCurrentFilterValues(filterValues);

    const req = {
      OrgId: props.portalsBlock.selectedHetPayId,
      FromDate: filterValues?.startDate || '',
      ToDate: filterValues?.endDate || '',
      FuStatus: filterValues.fuStatusDescription || '',
      AllContactPersons: filterValues.openedBy === 'my' ? 'false' : 'true',
      FuSubscriberOrId: filterValues.fuSubscriberOrFuId || '',
    };

    if (filterValues.openedBy === 'all') {
      setShowOpenedBy(true);
    } else {
      setShowOpenedBy(false);
    }
    // Call your API
    props.fetchExistingRequests(req);
  }
  function onClearFilters() {
    // Clear saved filter values
    setCurrentFilterValues(null);
    setShowOpenedBy(false);
    //get new data without filtering
    props.fetchExistingRequests({OrgId: props.portalsBlock.selectedHetPayId});
  }

  // Calculate default dates
  const getDefaultDates = () => {
    const today = new Date();
    const fourteenDaysAgo = new Date();
    const fiveHundredsDaysAgo = new Date();
    fourteenDaysAgo.setDate(today.getDate() - 14);
    fiveHundredsDaysAgo.setDate(today.getDate() - 500);
    return {
      startDate: getFormatDate(fourteenDaysAgo),
      endDate: getFormatDate(today),
      minDate: getFormatDate(fiveHundredsDaysAgo),
    };
  };

  // Define filter configuration
  const tableFilterOptions = {
    fields: [
      {
        key: 'openedBy',
        type: 'select',
        placeholder: 'הצג: פניות שלי',
        value: 'my',
        width: '20%',
        options: [
          {value: 'הצג: פניות שלי', key: 'my'},
          {value: 'הצג:  כל הפניות ', key: 'all'},
        ],
      },
      {
        key: 'fuStatusDescription',
        type: 'select',
        placeholder: 'סטטוס',
        width: '10%',
        options: [
          {value: 'הכל ', key: ''},
          {value: 'פתוח', key: 'בטיפול'},
          {value: 'סגור', key: 'סגור'},
        ],
      },
      {
        key: 'fuSubscriberOrFuId',
        type: 'text',
        placeholder: 'חיפוש לפי מס׳ מנוי או מס׳ פניה',
        width: '30%',
      },
      {
        key: 'dateRange',
        type: 'dateRange',
        width: '40%',
        defaultValue: getDefaultDates(),
        minDate: getDefaultDates()?.minDate,
        maxDate: new Date(),
        numOfYearsBack: 2,
      },
    ],
    showClearButton: true,
  };

  // Mobile filter configuration
  const mobileFilterOptions = {
    fields: [
      {
        key: 'openedBy',
        type: 'select',
        placeholder: 'הצג: פניות שלי',
        value: 'my',
        options: [
          {value: 'הצג: פניות שלי', key: 'my'},
          {value: 'הצג: כל הפניות', key: 'all'},
        ],
      },
    ],
    popupFields: [
      {
        key: 'fuSubscriberOrFuId',
        type: 'textWithActions',
        placeholder: 'הכנס מספר מנוי או מספר פניה',
        actionText: 'חיפוש',
        onClear: (filterValues) => {
          props.fetchExistingRequests({OrgId: props.portalsBlock.selectedHetPayId});
        },
      },
    ],
    showClearButton: false,
    onPopupSearch: (filterValues) => {
      // Handle popup search
      const req = {
        OrgId: props.portalsBlock.selectedHetPayId,
        AllContactPersons: filterValues.openedBy === 'my' ? 'false' : 'true',
        FuSubscriberOrId: filterValues.fuSubscriberOrFuId || '',
      };
      props.fetchExistingRequests(req);
    },
    // Handle mobile filter changes
    handleFilterChange: (key, value, allFilters) => {
      // Handle immediate filtering for main field (like openedBy)
      if (key === 'openedBy') {
        const req = {
          OrgId: props.portalsBlock.selectedHetPayId,
          AllContactPersons: value === 'my' ? 'false' : 'true',
        };
        props.fetchExistingRequests(req);
      }
    },
  };

  // Render the "פניה חדשה" button for mobile filter bar
  const renderNewRequestButton = () => (
    <BtnNextStep
      nextStep={BusinessWorkOrderSystemStep.WorkOrderTypeSelecting}
      className='btn-submit-new-fu'
      text={
        <>
          <Image src={require('../Icons/plus.svg')} alt='new fu' />
          <span>פניה חדשה</span>
        </>
      }
    />
  );

  // Define table columns configuration
  const tableColumns = [
    {
      key: 'fuOpenDateFormatted',
      title: 'תאריך פתיחה',
      type: 'text',
      sortable: true,
      align: 'right',
      width: '10%',
    },
    {
      key: 'fuId',
      title: 'מספר פנייה',
      type: 'text',
      sortable: true,
      align: 'right',
      width: showOpenedBy ? '9%' : '10%',
    },
    {
      key: 'fuSubscriber',
      title: 'מס׳ מנוי',
      type: 'text',
      sortable: false,
      align: 'right',
      width: showOpenedBy ? '9%' : '10%',
      className: 'bold',
    },
    {
      key: 'fuStatusDescription',
      title: 'סטטוס',
      type: 'text',
      sortable: false,
      align: 'right',
      width: showOpenedBy ? '6%' : '7%',
    },
    {
      key: 'futpSystemTxt',
      title: 'סוג',
      type: 'text',
      sortable: false,
      align: 'right',
      width: showOpenedBy ? '13%' : '14%',
    },
    {
      key: 'futpFuDescription',
      title: 'נושא',
      type: 'text',
      sortable: false,
      align: 'right',
      width: showOpenedBy ? '11%' : '12%',
    },
    {
      key: 'fuDueDateFormatted',
      title: 'תאריך יעד',
      type: 'text',
      sortable: false,
      align: 'right',
      width: showOpenedBy ? '8%' : '9%',
    },
    {
      key: 'fuCloseDateFormatted',
      title: 'תאריך סגירה',
      type: 'custom',
      sortable: false,
      align: 'right',
      width: showOpenedBy ? '9%' : '10%',
      render: (value, item) => (
        <div className=''>
          {item.fuStatusDescription !== 'סגור' ? (
            <span>-----</span>
          ) : (
            <span className=''>{formatDateString14digits(item.fuCloseDate)}</span>
          )}
        </div>
      ),
    },
    {
      key: 'secondaryActions',
      title: 'פ.משנית',
      type: 'custom',
      align: 'right',
      width: showOpenedBy ? '9%' : '10%',
      className: 'fu-close-date-button',
      render: (value, item) => (
        <div className=''>
          {item.fuStatusDescription === 'סגור' ? (
            !item.isReopenWo ? (
              <BtnWhiteBlackBorder text='פניה חוזרת' onclick={() => handleFuReopen(item)} />
            ) : null
          ) : (
            <BtnWhiteBlackBorder text='סגירת פניה ' onclick={() => closeFu(item)} />
          )}
        </div>
      ),
    },
    {
      key: 'detailsActions',
      title: 'פרטים',
      type: 'custom',
      align: 'right',
      width: showOpenedBy ? '6%' : '7%',
      render: (value, item) => (
        <div className=''>
          <a className='d-block' onClick={() => handleGetFuData(item)}>
            פרטים
          </a>
        </div>
      ),
    },
  ];

  // Conditionally add the openedBy column
  if (showOpenedBy) {
    tableColumns.splice(1, 0, {
      key: 'openedBy',
      title: 'פותח הפניה',
      type: 'text',
      sortable: false,
      align: 'right',
      width: '9%',
    });
  }

  const tableColumnsMobile = [
    {
      key: 'fuOpenDateFormatted',
      title: 'ת. פתיחה',
      type: 'text',
      sortable: true,
      align: 'right',
      width: '26%',
    },
    {
      key: 'fuId',
      title: 'מס׳ פניה',
      type: 'text',
      sortable: true,
      align: 'right',
      width: '24%',
    },

    {
      key: 'futpFuDescription',
      title: 'נושא הפניה',
      type: 'text',
      sortable: false,
      align: 'right',
      width: '25%',
    },
    {
      key: 'fuStatusDescription',
      title: 'סטטוס',
      type: 'text',
      sortable: true,
      align: 'right',
      width: '25%',
    },
    {
      key: 'collapsed',
      type: 'collapsed',
      align: 'right',
      width: '100%',
      className: '',
      render: (value, item) => (
        <div className='collapsed-content-details'>
          <div className='collapsed-grid'>
            <div className='grid-row'>
              <div className='grid-item'>
                <div className='label'>סוג</div>
                <div className='value'>{item.futpSystemTxt}</div>
              </div>
              <div className='grid-item'>
                <div className='label'>פותח הפניה</div>
                <div className='value'>{item.openedBy || '------'}</div>
              </div>
              <div className='grid-item'>
                <div className='label'>מס׳ מנוי</div>
                <div className='value'>{item.fuSubscriber || '------'}</div>
              </div>
            </div>
            <div className='grid-row'>
              <div className='grid-item'>
                <div className='label'>כותרת</div>
                <div className='value'>{item.fuTitle || '------'}</div>
              </div>
              <div className='grid-item'>
                <div className='label'>מס׳ לקוח</div>
                <div className='value'>{item.fuBan || '------'}</div>
              </div>
              <div className='grid-item'>
                <div className='label'>צפי לטיפול</div>
                <div className='value'>{item.fuDueDateFormatted}</div>
              </div>
            </div>
          </div>
          <div className='collapsed-actions'>
            <div className='action-buttons'>
              <a className='details-link' onClick={() => handleGetFuData(item)}>
                לפרטים
              </a>

              {item.fuStatusDescription === 'סגור' ? (
                !item.isReopenWo ? (
                  <BtnWhiteBlackBorder text='פניה חוזרת' onclick={() => handleFuReopen(item)} />
                ) : null
              ) : (
                <BtnWhiteBlackBorder text='סגירת פניה ' onclick={() => closeFu(item)} />
              )}
            </div>
          </div>
        </div>
      ),
    },
  ];
  const filterOptions = {
    tableFilters: isMobile ? mobileFilterOptions : tableFilterOptions,
    showFilterBar: true,

    submitSearching: submitSearching,
    onClearFilters: onClearFilters,
    renderExtraButton: isMobile ? renderNewRequestButton : null,
    onFilterChange: onFilterChange,
  };

  const tableOptions = {
    tableColumns: isMobile ? tableColumnsMobile : tableColumns,
    collapsedRow: isMobile ? true : false,
  };

  function onFilterChange(key, value, newValues) {
    console.log(key, value, newValues);
    if (isMobile && key == 'openedBy') {
      submitSearching(newValues);
    }
  }
  // Action handlers
  const handleFuReopen = (item) => {
    props.setSelectedWorkOrderRow(item);
    props.setCurrentStep(BusinessWorkOrderSystemStep.ReopenWorkOrder);
  };

  function closeFu(item) {
    const fuData = props.businessWorkOrderSystem.dashboardData.find((row) => row.fuId === item.fuId);
    props.setCurrentPopUp({currentPopUp: BusinessWorkOrderSystemPopup.CloseFU, currentPopupData: fuData});
  }

  const handleGetFuData = (item) => {
    const fuData = props.businessWorkOrderSystem.dashboardData.find((row) => row.fuId === item.fuId);
    if (fuData) {
      props.getWorkOrderData({fu_number: item.fuId, fu_ban: fuData.fuBan});
    }
  };

  const handleSort = (columnKey, direction) => {
    //to do
    console.log('Sort by:', columnKey, direction);

    // Add your sorting logic here if needed
  };

  const getCSVData = () => {
    const formattedData = props.businessWorkOrderSystem.dashboardData.map((row) => ({
      'תאריך פתיחה': formatDateString14digits(row.fuOpenDate),
      'מספר פניה': row.fuId,
      'מספר מנוי': row.fuSubscriber,
      ' סטטוס': row.fuStatusDescription,
      ' סוג': row.futpSystemTxt,
      ' נושא': row.futpFuDescription,
      ' צפי לטיפול': formatDateString14digits(row.fuDueDate),
      ' תאריך סגירה': row.fuCloseDate ? formatDateString14digits(row.fuCloseDate) : '',
    }));
    return formattedData;
  };
  const validateSelectedOrg = (selectedOrgId) => {
    if (selectedOrgId && selectedOrgId !== props.portalsBlock.selectedHetPay) {
      props.setSelectedHetPayAllowedToActions(true);
      // Clear filter values when organization changes
      setCurrentFilterValues(null);
      setShowOpenedBy(false);
      props.setSelectedHetPay(selectedOrgId);
      const selectedOrg = props.portalsBlock.privateCompanyList.find((org) => org.idNumber == selectedOrgId);

      if (!selectedOrg.cellInd || !selectedOrg.allowedCellular) {
        props.setSelectedHetPayAllowedToActions(false);
      } else {
        const req = {
          OrgId: selectedOrg.orgId,
        };
        props.fetchExistingRequests(req);
      }
    }
  };

  return (
    <div className='business-work-order-system_dashboard'>
      <div className='l-title'>ניהול פניות</div>
      <div className='selected-org-name'>
        <ReactSelect
          getOptionLabel={(option) => option.value}
          getOptionValue={(option) => option.key}
          value={props.portalsBlock.selectCompanyOptions?.filter((option) => option.key == props.portalsBlock.selectedHetPay)}
          name='selected'
          options={props.portalsBlock.selectCompanyOptions}
          onChange={(e) => validateSelectedOrg(e.key)}
        />
        {!props.portalsBlock.selectedHetPayAllowedToActions && (
          <div className='center error'>מצטערים אין לך הרשאה לבצע את הפעולה עבור חברה זו</div>
        )}
      </div>
      <div className='dashboard-wrapper'>
        {/* Desktop new request button - only show on desktop */}
        {!isMobile && <div className='d-flex justify-content-between align-items-center d-none d-md-block'>{renderNewRequestButton()}</div>}

        <FlexibleTable
          key={props.portalsBlock.selectedHetPayId} // Reset filters when org changes
          columns={tableOptions}
          filterOptions={filterOptions}
          data={props.businessWorkOrderSystem.dashboardData}
          onSort={handleSort}
          pagination={true}
          pageSize={10}
          hasMoreData={props.businessWorkOrderSystem.moreRows}
          onLoadMore={() => {
            loadMore();
          }}
          showDownloadButton={isMobile ? false : true}
          getCSVData={getCSVData}
          downloadFileTitle='ניהול פניות'
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
  portalsBlock: state.portalsBlock,
});
const mapDispatchToProps = {
  fetchExistingRequests,
  setCurrentStep,
  getWorkOrderData,
  setCurrentPopUp,
  saveToHistory,
  setLoadingMoreRows,
  setSelectedHetPayAllowedToActions,
  setSelectedHetPay,
  setSelectedWorkOrderRow,
  resetWorkOrderData,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderDashboard);
